module.exports = __webpack_public_path__ + "img/face40.53124140.gif";